import { SchedulingLabel } from 'generated';
import { useTranslation } from 'react-i18next';

import { Event } from '../../types';

import { Drawer } from 'components/shared';

import AddEditAppointmentForm from './AddEditAppointmentForm';

type Props = {
  open: boolean;
  handleClose: () => void;
  schedulingLabel: SchedulingLabel;
  appointment?: Event;
  events?: Event[];
  isEmployeePerspective?: boolean;
};

export default function AddEditAppointmentDrawer({
  open,
  handleClose,
  appointment,
  schedulingLabel,
  events,
  isEmployeePerspective
}: Props) {
  const { t } = useTranslation('common', { keyPrefix: 'activityPlanning' });

  return (
    <Drawer
      title={appointment ? t('editAppointment') : t('addAppointment')}
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{ width: '400px' }}
    >
      {open && ( // Don't fetch data until drawer is open
        <AddEditAppointmentForm
          appointment={appointment}
          schedulingLabel={schedulingLabel}
          events={events}
          handleClose={handleClose}
          isEmployeePerspective={isEmployeePerspective}
        />
      )}
    </Drawer>
  );
}
